var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "49px",
    height: "33px",
    viewBox: "0 0 49 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Customer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 14,
    transform: "translate(-29.000000, -116.000000)",
    stroke: "var(--brand-secondary)",
    strokeWidth: 1.30000007
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Customer",
    transform: "translate(30.000000, 117.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(33.307692, 11.041667)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 6.84615399,
    cy: 3.3178106,
    rx: 3.3589745,
    ry: 3.3178106
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,18.6666667 L0,13.8229167 C0,10.7911035 3.06512755,8.33333333 6.846154,8.33333333 L6.846154,8.33333333 C10.6271804,8.33333333 13.692308,10.7911035 13.692308,13.8229167 L13.692308,18.6666667",
    id: "Path",
    fill: "#FFFFFF",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(0.000000, 9.041667)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 7.84615385,
    cy: 4.30555556,
    rx: 4.35897436,
    ry: 4.30555556
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,20.6666667 L0,15.8229167 C0,12.7911035 3.51284273,10.3333333 7.84615385,10.3333333 L7.84615385,10.3333333 C12.179465,10.3333333 15.6923077,12.7911035 15.6923077,15.8229167 L15.6923077,20.6666667",
    id: "Path",
    fill: "#FFFFFF",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(14.384615, 0.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 11.7692308,
    cy: 6.45833333,
    rx: 6.53846154,
    ry: 6.45833333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,31 L0,23.734375 C0,19.1866553 5.2692641,15.5 11.7692308,15.5 L11.7692308,15.5 C18.2691974,15.5 23.5384615,19.1866553 23.5384615,23.734375 L23.5384615,31",
    id: "Path",
    fill: "#FFFFFF",
    strokeLinecap: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.6e01e7c621d800e7d8308ce501f31f0a.svg";
export { ForwardRef as ReactComponent };